// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const fr: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'Comment jouer',
  'howto.pieces.heading': 'Les pièces',
  'howto.pieces.source': 'Source',
  'howto.pieces.mirror': 'Miroir',
  'howto.pieces.switch': 'Interrupteur',
  'howto.pieces.exit': 'Sortie',
  'howto.pieces.wall': 'Mur',
  'howto.controls.heading': 'Les commandes',
  'howto.controls.clickSlot.line1': 'Clique sur la case',
  'howto.controls.clickSlot.line2': 'place le miroir',
  'howto.controls.dragMirror.line1': 'Fais glisser le miroir',
  'howto.controls.dragMirror.line2': 'pivote',
  'howto.controls.rightClick.line1': 'Clic droit',
  'howto.controls.rightClick.line2': 'retire le miroir',
  'howto.controls.hint': 'Molette : rotation fine de 1°.   Tape sur le miroir : rotation de 15°.',
  'howto.objective.line1': 'Allume chaque interrupteur — le verrou de la sortie s’ouvre.',
  'howto.objective.line2': 'Puis clique sur la sortie. Résous avec le moins de miroirs possible.',

  'howtoColor.title': 'Couleur et prismes',
  'howtoColor.pieces.heading': 'Nouvelles pièces',
  'howtoColor.pieces.prism': 'Prisme',
  'howtoColor.pieces.redSwitch': 'Interrupteur rouge',
  'howtoColor.pieces.yellowSwitch': 'Interrupteur jaune',
  'howtoColor.pieces.whiteSwitch': 'Interrupteur blanc',
  'howtoColor.how.heading': 'Comment ça marche',
  'howtoColor.how.line1': 'Un rayon blanc transporte la lumière rouge, verte et bleue à la fois.',
  'howtoColor.how.line2':
    'Un prisme sépare la lumière blanche en trois rayons colorés sur ses trois côtés.',
  'howtoColor.how.line3': 'Clique sur un prisme placé pour faire tourner sa face d’entrée.',
  'howtoColor.switches.line1':
    'Les interrupteurs montrent des points de couleur — c’est la couleur qu’ils demandent.',
  'howtoColor.switches.line2':
    'Un interrupteur jaune (points rouge + vert) a besoin des deux couleurs en même temps.',
  'howtoColor.switches.line3':
    'Un interrupteur blanc (les trois) a besoin de rouge, vert ET bleu à la fois.',

  'options.hints.label': 'Afficher les angles d’aide dans les puzzles',
  'options.hints.help':
    'Affiche l’angle entre le rayon entrant et le rayon réfléchi à chaque rebond.',

  'level.01-intro.title': 'Bonjour, lumière',
  'level.02-two-mirrors.title': 'Deux virages',
  'level.03-corner.title': 'Mur sur le chemin',
  'level.04-two-targets.title': 'Deux cibles',
  'level.05-tight.title': 'Serré',
  'level.06-hello-color.title': 'Bonjour, couleur',
  'level.07-pick-a-side.title': 'Choisis un côté',
  'level.08-yellow.title': 'Jaune',
  'level.09-magenta.title': 'Magenta',
  'level.10-spectrum.title': 'Spectre',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'droit',
  'puzzle.hint.angleType.acute': 'aigu',
  'puzzle.hint.angleType.obtuse': 'obtus',
  'puzzle.hint.label': '{angle}°\n{type}',
};
